import { forwardRef } from 'react'
import { getIn } from 'formik'
import { TextArea } from '../../TextArea'

export const TextAreaForm = forwardRef(
  ({ field, form, sizeInput, label = null, max, ...props }, ref) => {
    const handleChange = (e) => {
      if (max) {
        form.setFieldValue(field.name, e.target.value.substring(0, max))
      } else {
        form.setFieldValue(field.name, e.target.value)
      }
    }

    const error = getIn(form.errors, field.name)
    const touched = getIn(form.touched, field.name)

    return (
      <TextArea
        ref={ref}
        name={field.name}
        label={label}
        isInvalid={!!error && !!touched}
        value={field.value}
        onChange={handleChange}
        {...props}
      />
    )
  }
)
